var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCelebrationTrophy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 283.777,
    height: 119.701,
    viewBox: "0 0 283.777 119.701",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3660",
    "data-name": "Group 3660",
    transform: "translate(-46.825 -142.079)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "np_trophy_670335_000000",
    d: "M20.454,40.663H22.6A24.194,24.194,0,0,0,39.521,54.307v7.949H33.595a3.313,3.313,0,0,0-3.312,3.312v4.347H27.326a2.1,2.1,0,0,0-2.139,2.153V83.362A2.111,2.111,0,0,0,27.3,85.473H61.9a2.109,2.109,0,0,0,2.146-2.111V72.067a2.111,2.111,0,0,0-2.111-2.111H58.951V65.612A3.31,3.31,0,0,0,55.64,62.3H49.713V54.307A24.194,24.194,0,0,0,66.634,40.663H68.78A16.526,16.526,0,0,0,85.3,24.128V14.089a2.65,2.65,0,0,0-2.65-2.65H68.78V6.361a2.65,2.65,0,0,0-2.65-2.65H23.093a2.65,2.65,0,0,0-2.65,2.65V11.45l-13.872,0a2.648,2.648,0,0,0-2.65,2.65V24.128A16.52,16.52,0,0,0,20.454,40.663ZM68.78,30.71v-10.9h8.162v4.316a8.172,8.172,0,0,1-8.162,8.162h-.052c.024-.521.052-1.052.052-1.58Zm-34.5-7.383,5.961-.883a1.047,1.047,0,0,0,.776-.566l2.65-5.4a1.033,1.033,0,0,1,1.856,0l2.65,5.4a1.035,1.035,0,0,0,.776.566l5.961.883a1.033,1.033,0,0,1,.573,1.766L51.179,29.3v0a1.04,1.04,0,0,0-.3.883l1.014,5.934a1.032,1.032,0,0,1-1.5,1.087l-5.3-2.8v0a1.032,1.032,0,0,0-.962,0l-5.3,2.8v0a1.033,1.033,0,0,1-1.5-1.087l1.014-5.934a1.03,1.03,0,0,0-.3-.883L33.736,25.09v0a1.032,1.032,0,0,1,.549-1.766ZM12.3,19.794h8.159V30.709c0,.531,0,1.059.052,1.58h-.052a8.172,8.172,0,0,1-8.162-8.162Z",
    transform: "translate(141.902 165.17)",
    fill: "#84f08d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3491",
    "data-name": "Group 3491",
    transform: "translate(46.825 142.079)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1978",
    "data-name": "Path 1978",
    d: "M11.057,16.419a10.418,10.418,0,0,0,1.576-1.646,10.344,10.344,0,0,0,1.888-4.05,10.461,10.461,0,0,0,0-4.53,10.341,10.341,0,0,0-1.888-4.049A10.421,10.421,0,0,0,11.057.5,2.13,2.13,0,1,0,8.319,3.762a6.169,6.169,0,0,1,.929.972,6.107,6.107,0,0,1,1.113,2.389,6.175,6.175,0,0,1,0,2.672,6.127,6.127,0,0,1-2.042,3.362L3.713,17.021a10.385,10.385,0,0,0,0,15.923l4.606,3.869a6.129,6.129,0,0,1,0,9.392L3.713,50.07a10.381,10.381,0,0,0,0,15.921l4.606,3.866a6.13,6.13,0,0,1,0,9.394A2.137,2.137,0,0,0,8.4,82.584a2.1,2.1,0,0,0,.4.238,2.126,2.126,0,0,0,.434.144,2.153,2.153,0,0,0,.453.048,2.117,2.117,0,0,0,1.053-.281,2.173,2.173,0,0,0,.314-.219,10.418,10.418,0,0,0,1.576-1.646,10.344,10.344,0,0,0,1.888-4.05,10.462,10.462,0,0,0,0-4.53,10.344,10.344,0,0,0-1.888-4.05,10.419,10.419,0,0,0-1.576-1.646L6.451,62.725a6.131,6.131,0,0,1,0-9.393l4.606-3.864a10.412,10.412,0,0,0,1.576-1.646,10.35,10.35,0,0,0,1.888-4.051,10.463,10.463,0,0,0,0-4.53,10.352,10.352,0,0,0-3.464-5.694L6.451,29.681a6.126,6.126,0,0,1,0-9.394Z",
    transform: "translate(0 19.277)",
    fill: "#121e59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1979",
    "data-name": "Path 1979",
    d: "M14.769,74.554a10.431,10.431,0,0,0-.248-2.265,10.349,10.349,0,0,0-1.889-4.05,10.425,10.425,0,0,0-1.575-1.646L6.449,62.727a6.132,6.132,0,0,1,0-9.394l4.608-3.865a10.42,10.42,0,0,0,1.575-1.646,10.355,10.355,0,0,0,1.889-4.05,10.452,10.452,0,0,0,0-4.529,10.359,10.359,0,0,0-3.464-5.7L6.449,29.68a6.129,6.129,0,0,1,0-9.394l4.608-3.867a10.425,10.425,0,0,0,1.575-1.646,10.349,10.349,0,0,0,1.889-4.05,10.452,10.452,0,0,0,0-4.529,10.349,10.349,0,0,0-1.889-4.05A10.425,10.425,0,0,0,11.057.5,2.135,2.135,0,0,0,8.716.233a2.1,2.1,0,0,0-.659.528,2.126,2.126,0,0,0,.262,3,6.168,6.168,0,0,1,.93.972,6.1,6.1,0,0,1,1.114,2.389,6.174,6.174,0,0,1,0,2.672,6.107,6.107,0,0,1-1.114,2.39,6.165,6.165,0,0,1-.93.972L3.71,17.023a10.385,10.385,0,0,0,0,15.921l4.608,3.869a6.122,6.122,0,0,1,0,9.389L3.71,50.069a10.387,10.387,0,0,0,0,15.921l4.608,3.866a6.128,6.128,0,0,1,0,9.394A2.138,2.138,0,0,0,8.4,82.583a2.1,2.1,0,0,0,.4.238,2.126,2.126,0,0,0,.434.144,2.152,2.152,0,0,0,.453.048,2.117,2.117,0,0,0,1.053-.28,2.174,2.174,0,0,0,.314-.219,10.426,10.426,0,0,0,1.575-1.646,10.349,10.349,0,0,0,1.889-4.05A10.426,10.426,0,0,0,14.769,74.554Z",
    transform: "translate(35.676)",
    fill: "#ff808a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1980",
    "data-name": "Path 1980",
    d: "M11.057,49.468a10.416,10.416,0,0,0,1.576-1.646,10.342,10.342,0,0,0,1.888-4.051,10.483,10.483,0,0,0,0-4.53,10.36,10.36,0,0,0-3.463-5.694L6.449,29.681a6.131,6.131,0,0,1,0-9.394l4.608-3.867a10.41,10.41,0,0,0,1.576-1.646,10.346,10.346,0,0,0,1.888-4.05,10.465,10.465,0,0,0,0-4.529,10.34,10.34,0,0,0-1.888-4.049A10.415,10.415,0,0,0,11.057.5a2.1,2.1,0,0,0-.741-.406,2.13,2.13,0,0,0-2,3.668,6.177,6.177,0,0,1,.928.972,6.136,6.136,0,0,1-.928,8.423L3.711,17.023a10.384,10.384,0,0,0,0,15.921L8.319,36.81a6.147,6.147,0,0,1,2.042,6.031A6.121,6.121,0,0,1,8.319,46.2L3.711,50.07a10.385,10.385,0,0,0,0,15.921l4.608,3.866a6.134,6.134,0,0,1,0,9.394,2.13,2.13,0,0,0,.918,3.715,2.15,2.15,0,0,0,.453.048,2.117,2.117,0,0,0,1.367-.5,10.407,10.407,0,0,0,1.576-1.646,10.349,10.349,0,0,0,1.888-4.051,10.464,10.464,0,0,0,0-4.529,10.343,10.343,0,0,0-1.888-4.05,10.413,10.413,0,0,0-1.576-1.646L6.449,62.727a6.132,6.132,0,0,1,0-9.393Z",
    transform: "translate(67.354 30.695)",
    fill: "#91f2ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1111",
    "data-name": "Rectangle 1111",
    d: "M0,0H4.262V4.262H0Z",
    transform: "translate(24.965 42.896)",
    fill: "#ffef73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1117",
    "data-name": "Rectangle 1117",
    d: "M0,0H4.262V4.262H0Z",
    transform: "translate(24.965 88.722)",
    fill: "#ffef73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1112",
    "data-name": "Rectangle 1112",
    d: "M0,0H4.262V4.262H0Z",
    transform: "translate(53.372 60.785)",
    fill: "#121e59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1115",
    "data-name": "Rectangle 1115",
    d: "M0,0H4.262V4.262H0Z",
    transform: "translate(63.092 72.202)",
    fill: "#84f08d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1116",
    "data-name": "Rectangle 1116",
    d: "M0,0H4.262V4.262H0Z",
    transform: "translate(65.14 102.293)",
    fill: "#ff808a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1113",
    "data-name": "Rectangle 1113",
    d: "M0,0H4.262V4.262H0Z",
    transform: "translate(55.503 28.966)",
    fill: "#ffef73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1114",
    "data-name": "Rectangle 1114",
    d: "M0,0H4.262V4.262H0Z",
    transform: "translate(38.799 100.161)",
    fill: "#ffba7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1981",
    "data-name": "Path 1981",
    d: "M7.423.625l-6.8,6.8A2.131,2.131,0,0,0,3.3,10.71a2.147,2.147,0,0,0,.335-.273l6.8-6.8A2.131,2.131,0,1,0,7.423.625Z",
    transform: "translate(56.208 38.269)",
    fill: "#ffba7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1988",
    "data-name": "Path 1988",
    d: "M7.423.625l-6.8,6.8A2.131,2.131,0,0,0,3.3,10.71a2.147,2.147,0,0,0,.335-.273l6.8-6.8A2.131,2.131,0,1,0,7.423.625Z",
    transform: "translate(56.208 6.451)",
    fill: "#ffba7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1982",
    "data-name": "Path 1982",
    d: "M10.435.624a2.129,2.129,0,0,0-3.013,0l-6.8,6.8a2.131,2.131,0,1,0,3.014,3.014l6.8-6.8a2.129,2.129,0,0,0,0-3.013Z",
    transform: "translate(19.693 62.411)",
    fill: "#ffba7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1987",
    "data-name": "Path 1987",
    d: "M10.435.624a2.129,2.129,0,0,0-3.013,0l-6.8,6.8a2.131,2.131,0,1,0,3.014,3.014l6.8-6.8a2.129,2.129,0,0,0,0-3.013Z",
    transform: "translate(19.693 16.584)",
    fill: "#91f2ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1986",
    "data-name": "Path 1986",
    d: "M10.435.624a2.129,2.129,0,0,0-3.013,0l-6.8,6.8a2.131,2.131,0,1,0,3.014,3.014l6.8-6.8a2.129,2.129,0,0,0,0-3.013Z",
    transform: "translate(19.693 108.237)",
    fill: "#91f2ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1983",
    "data-name": "Path 1983",
    d: "M7.421.625l-6.8,6.8a2.13,2.13,0,0,0,0,3.014,2.15,2.15,0,0,0,.335.273,2.131,2.131,0,0,0,2.345,0,2.15,2.15,0,0,0,.335-.273l6.8-6.8A2.131,2.131,0,1,0,7.421.625Z",
    transform: "translate(48.55 86.069)",
    fill: "#91f2ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3490",
    "data-name": "Group 3490",
    transform: "translate(249.577 144.079)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1978-2",
    "data-name": "Path 1978",
    d: "M3.663,65.7a10.243,10.243,0,0,0,0,15.707,2.1,2.1,0,1,0,2.7-3.219,6.05,6.05,0,0,1,0-9.269l4.544-3.812a10.285,10.285,0,0,0,1.555-1.624,10.207,10.207,0,0,0,1.864-4,10.316,10.316,0,0,0,0-4.47,10.214,10.214,0,0,0-1.864-4A10.277,10.277,0,0,0,10.909,49.4L6.365,45.583a6.047,6.047,0,0,1,0-9.266L10.909,32.5a10.278,10.278,0,0,0,1.555-1.624,10.213,10.213,0,0,0,1.864-4,10.313,10.313,0,0,0,0-4.469,10.2,10.2,0,0,0-1.864-4A10.276,10.276,0,0,0,10.909,16.8L6.365,12.981a6.048,6.048,0,0,1,0-9.268A2.109,2.109,0,0,0,6.282.425,2.072,2.072,0,0,0,5.888.189,2.1,2.1,0,0,0,5.46.047,2.123,2.123,0,0,0,5.012,0,2.089,2.089,0,0,0,3.973.277a2.145,2.145,0,0,0-.31.216,10.244,10.244,0,0,0,0,15.708l4.544,3.817a6.049,6.049,0,0,1,0,9.267L3.663,33.1a10.241,10.241,0,0,0,0,15.708L8.207,52.62a6.055,6.055,0,0,1,1.6,7.193,6.037,6.037,0,0,1-1.6,2.075Z",
    transform: "translate(66.452 16.777)",
    fill: "#121e59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1979-2",
    "data-name": "Path 1979",
    d: "M0,8.347A10.232,10.232,0,0,0,3.663,16.2l4.546,3.815a6.05,6.05,0,0,1,0,9.268L3.663,33.1a10.243,10.243,0,0,0,0,15.708L8.209,52.62A6.06,6.06,0,0,1,9.8,59.813a6.035,6.035,0,0,1-1.594,2.075L3.663,65.7a10.245,10.245,0,0,0,0,15.707,2.107,2.107,0,0,0,2.31.263A2.123,2.123,0,0,0,7.024,80.42a2.1,2.1,0,0,0-.658-2.228,6.052,6.052,0,0,1-1.6-2.078,6.049,6.049,0,0,1,1.6-7.191l4.546-3.815a10.27,10.27,0,0,0,1.553-1.622,10.209,10.209,0,0,0,1.863-3.995,10.343,10.343,0,0,0,0-4.47,10.207,10.207,0,0,0-1.863-4A10.277,10.277,0,0,0,10.912,49.4L6.366,45.584a6.04,6.04,0,0,1,0-9.264L10.912,32.5a10.277,10.277,0,0,0,1.554-1.624,10.207,10.207,0,0,0,1.863-4,10.343,10.343,0,0,0,0-4.469,10.209,10.209,0,0,0-1.863-3.995A10.282,10.282,0,0,0,10.912,16.8L6.366,12.981a6.046,6.046,0,0,1,0-9.268A2.109,2.109,0,0,0,6.282.425,2.072,2.072,0,0,0,5.888.19,2.1,2.1,0,0,0,5.459.048,2.123,2.123,0,0,0,5.012,0,2.089,2.089,0,0,0,3.973.277a2.144,2.144,0,0,0-.31.216A10.232,10.232,0,0,0,0,8.347Z",
    transform: "translate(31.253 35.797)",
    fill: "#ff808a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1980-2",
    "data-name": "Path 1980",
    d: "M3.662,33.1a10.244,10.244,0,0,0,0,15.708L8.208,52.62A6.062,6.062,0,0,1,9.8,59.813a6.037,6.037,0,0,1-1.593,2.075L3.662,65.7a10.243,10.243,0,0,0,0,15.707,2.076,2.076,0,0,0,.731.4,2.1,2.1,0,0,0,1.971-3.619A6.064,6.064,0,0,1,4.77,76.115a6.051,6.051,0,0,1,.678-6.232,6.092,6.092,0,0,1,.916-.959l4.546-3.815a10.269,10.269,0,0,0,1.554-1.622,10.206,10.206,0,0,0,1.863-3.995,10.333,10.333,0,0,0,0-4.47A10.223,10.223,0,0,0,10.909,49.4L6.363,45.586a6.047,6.047,0,0,1,0-9.266L10.909,32.5a10.271,10.271,0,0,0,1.555-1.624,10.207,10.207,0,0,0,1.863-4,10.331,10.331,0,0,0,0-4.469,10.209,10.209,0,0,0-1.863-4A10.278,10.278,0,0,0,10.909,16.8L6.363,12.981a6.052,6.052,0,0,1,0-9.268A2.107,2.107,0,0,0,6.28.425,2.084,2.084,0,0,0,5.458.048,2.121,2.121,0,0,0,5.011,0,2.089,2.089,0,0,0,3.662.493a10.245,10.245,0,0,0,0,15.708l4.546,3.815a6.05,6.05,0,0,1,0,9.267Z",
    transform: "translate(0.001 5.512)",
    fill: "#e2b8e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1111-2",
    "data-name": "Rectangle 1111",
    d: "M4.206,4.2H0V0H4.206Z",
    transform: "translate(52.188 71.173)",
    fill: "#ffef73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1117-2",
    "data-name": "Rectangle 1117",
    d: "M4.206,4.205H0V0H4.206Z",
    transform: "translate(52.188 25.959)",
    fill: "#ffef73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1112-2",
    "data-name": "Rectangle 1112",
    d: "M4.205,4.205H0V0H4.205Z",
    transform: "translate(24.161 53.523)",
    fill: "#ffef73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1115-2",
    "data-name": "Rectangle 1115",
    d: "M4.205,4.205H0V0H4.205Z",
    transform: "translate(14.571 42.259)",
    fill: "#84f08d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1116-2",
    "data-name": "Rectangle 1116",
    d: "M4.205,4.205H0V0H4.205Z",
    transform: "translate(12.551 12.57)",
    fill: "#ff808a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1113-2",
    "data-name": "Rectangle 1113",
    d: "M4.206,4.2H0V0H4.206Z",
    transform: "translate(22.058 84.916)",
    fill: "#ffef73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1114-2",
    "data-name": "Rectangle 1114",
    d: "M4.206,4.2H0V0H4.206Z",
    transform: "translate(38.538 14.674)",
    fill: "#121e59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1981-2",
    "data-name": "Path 1981",
    d: "M3.589,10.3,10.3,3.589A2.1,2.1,0,0,0,7.654.347a2.118,2.118,0,0,0-.33.27L.616,7.324A2.1,2.1,0,1,0,3.589,10.3Z",
    transform: "translate(14.654 69.029)",
    fill: "#121e59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1988-2",
    "data-name": "Path 1988",
    d: "M3.589,10.3,10.3,3.59A2.1,2.1,0,0,0,7.654.347a2.118,2.118,0,0,0-.33.27L.616,7.324A2.1,2.1,0,1,0,3.589,10.3Z",
    transform: "translate(14.654 100.422)",
    fill: "#ffba7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1982-2",
    "data-name": "Path 1982",
    d: "M.615,10.295a2.1,2.1,0,0,0,2.973,0l6.707-6.705A2.1,2.1,0,1,0,7.321.615L.615,7.322a2.1,2.1,0,0,0,0,2.973Z",
    transform: "translate(50.684 45.214)",
    fill: "#e2b8e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1987-2",
    "data-name": "Path 1987",
    d: "M.615,10.295a2.1,2.1,0,0,0,2.973,0l6.707-6.705A2.1,2.1,0,1,0,7.321.616L.615,7.322a2.1,2.1,0,0,0,0,2.973Z",
    transform: "translate(50.684 90.427)",
    fill: "#91f2ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1986-2",
    "data-name": "Path 1986",
    d: "M.615,10.295a2.1,2.1,0,0,0,2.973,0l6.707-6.705A2.1,2.1,0,1,0,7.321.615L.615,7.322a2.1,2.1,0,0,0,0,2.973Z",
    transform: "translate(50.684)",
    fill: "#ff808a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1983-2",
    "data-name": "Path 1983",
    d: "M3.588,10.295l6.707-6.705a2.1,2.1,0,0,0,0-2.974,2.121,2.121,0,0,0-.33-.269,2.1,2.1,0,0,0-2.314,0,2.121,2.121,0,0,0-.33.269L.615,7.322a2.1,2.1,0,1,0,2.973,2.973Z",
    transform: "translate(22.214 21.871)",
    fill: "#91f2ea"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelebrationTrophy);
export default __webpack_public_path__ + "static/media/celebration_trophy.256f554f486e6fd76fb360f84a1a4af2.svg";
export { ForwardRef as ReactComponent };